var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Card/CardFooter.js",
    _this = this;

import { FooterButton, FooterText, FooterWrapper } from './style';
import React from 'react';

var CardFooter = function CardFooter(_ref) {
  var rightContent = _ref.rightContent,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(FooterWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FooterText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement(FooterButton, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 7
    }
  }, rightContent));
};

export default CardFooter;